const {h} = require('./h');
function a(args, ...children) {return h('a', args, ...children)}
function abbr(args, ...children) {return h('abbr', args, ...children)}
function acronym(args, ...children) {return h('acronym', args, ...children)}
function address(args, ...children) {return h('address', args, ...children)}
function applet(args, ...children) {return h('applet', args, ...children)}
function area(args, ...children) {return h('area', args, ...children)}
function article(args, ...children) {return h('article', args, ...children)}
function aside(args, ...children) {return h('aside', args, ...children)}
function audio(args, ...children) {return h('audio', args, ...children)}
function b(args, ...children) {return h('b', args, ...children)}
function base(args, ...children) {return h('base', args, ...children)}
function basefont(args, ...children) {return h('basefont', args, ...children)}
function bdi(args, ...children) {return h('bdi', args, ...children)}
function bdo(args, ...children) {return h('bdo', args, ...children)}
function bgsound(args, ...children) {return h('bgsound', args, ...children)}
function big(args, ...children) {return h('big', args, ...children)}
function blink(args, ...children) {return h('blink', args, ...children)}
function blockquote(args, ...children) {return h('blockquote', args, ...children)}
function body(args, ...children) {return h('body', args, ...children)}
function br(args, ...children) {return h('br', args, ...children)}
function button(args, ...children) {return h('button', args, ...children)}
function canvas(args, ...children) {return h('canvas', args, ...children)}
function caption(args, ...children) {return h('caption', args, ...children)}
function center(args, ...children) {return h('center', args, ...children)}
function cite(args, ...children) {return h('cite', args, ...children)}
function code(args, ...children) {return h('code', args, ...children)}
function col(args, ...children) {return h('col', args, ...children)}
function colgroup(args, ...children) {return h('colgroup', args, ...children)}
function content(args, ...children) {return h('content', args, ...children)}
function data(args, ...children) {return h('data', args, ...children)}
function datalist(args, ...children) {return h('datalist', args, ...children)}
function dd(args, ...children) {return h('dd', args, ...children)}
function decorator(args, ...children) {return h('decorator', args, ...children)}
function del(args, ...children) {return h('del', args, ...children)}
function details(args, ...children) {return h('details', args, ...children)}
function dfn(args, ...children) {return h('dfn', args, ...children)}
function dir(args, ...children) {return h('dir', args, ...children)}
function div(args, ...children) {return h('div', args, ...children)}
function dl(args, ...children) {return h('dl', args, ...children)}
function dt(args, ...children) {return h('dt', args, ...children)}
function element(args, ...children) {return h('element', args, ...children)}
function em(args, ...children) {return h('em', args, ...children)}
function embed(args, ...children) {return h('embed', args, ...children)}
function fieldset(args, ...children) {return h('fieldset', args, ...children)}
function figcaption(args, ...children) {return h('figcaption', args, ...children)}
function figure(args, ...children) {return h('figure', args, ...children)}
function font(args, ...children) {return h('font', args, ...children)}
function footer(args, ...children) {return h('footer', args, ...children)}
function form(args, ...children) {return h('form', args, ...children)}
function frame(args, ...children) {return h('frame', args, ...children)}
function frameset(args, ...children) {return h('frameset', args, ...children)}
function h1(args, ...children) {return h('h1', args, ...children)}
function h2(args, ...children) {return h('h2', args, ...children)}
function h3(args, ...children) {return h('h3', args, ...children)}
function h4(args, ...children) {return h('h4', args, ...children)}
function h5(args, ...children) {return h('h5', args, ...children)}
function h6(args, ...children) {return h('h6', args, ...children)}
function head(args, ...children) {return h('head', args, ...children)}
function header(args, ...children) {return h('header', args, ...children)}
function hgroup(args, ...children) {return h('hgroup', args, ...children)}
function hr(args, ...children) {return h('hr', args, ...children)}
function html(args, ...children) {return h('html', args, ...children)}
function i(args, ...children) {return h('i', args, ...children)}
function iframe(args, ...children) {return h('iframe', args, ...children)}
function img(args, ...children) {return h('img', args, ...children)}
function input(args, ...children) {return h('input', args, ...children)}
function ins(args, ...children) {return h('ins', args, ...children)}
function isindex(args, ...children) {return h('isindex', args, ...children)}
function kbd(args, ...children) {return h('kbd', args, ...children)}
function keygen(args, ...children) {return h('keygen', args, ...children)}
function label(args, ...children) {return h('label', args, ...children)}
function legend(args, ...children) {return h('legend', args, ...children)}
function li(args, ...children) {return h('li', args, ...children)}
function link(args, ...children) {return h('link', args, ...children)}
function listing(args, ...children) {return h('listing', args, ...children)}
function main(args, ...children) {return h('main', args, ...children)}
function map(args, ...children) {return h('map', args, ...children)}
function mark(args, ...children) {return h('mark', args, ...children)}
function marquee(args, ...children) {return h('marquee', args, ...children)}
function menu(args, ...children) {return h('menu', args, ...children)}
function menuitem(args, ...children) {return h('menuitem', args, ...children)}
function meta(args, ...children) {return h('meta', args, ...children)}
function meter(args, ...children) {return h('meter', args, ...children)}
function nav(args, ...children) {return h('nav', args, ...children)}
function nobr(args, ...children) {return h('nobr', args, ...children)}
function noframes(args, ...children) {return h('noframes', args, ...children)}
function noscript(args, ...children) {return h('noscript', args, ...children)}
function object(args, ...children) {return h('object', args, ...children)}
function ol(args, ...children) {return h('ol', args, ...children)}
function optgroup(args, ...children) {return h('optgroup', args, ...children)}
function option(args, ...children) {return h('option', args, ...children)}
function output(args, ...children) {return h('output', args, ...children)}
function p(args, ...children) {return h('p', args, ...children)}
function param(args, ...children) {return h('param', args, ...children)}
function plaintext(args, ...children) {return h('plaintext', args, ...children)}
function pre(args, ...children) {return h('pre', args, ...children)}
function progress(args, ...children) {return h('progress', args, ...children)}
function q(args, ...children) {return h('q', args, ...children)}
function rp(args, ...children) {return h('rp', args, ...children)}
function rt(args, ...children) {return h('rt', args, ...children)}
function ruby(args, ...children) {return h('ruby', args, ...children)}
function s(args, ...children) {return h('s', args, ...children)}
function samp(args, ...children) {return h('samp', args, ...children)}
function script(args, ...children) {return h('script', args, ...children)}
function section(args, ...children) {return h('section', args, ...children)}
function select(args, ...children) {return h('select', args, ...children)}
function shadow(args, ...children) {return h('shadow', args, ...children)}
function small(args, ...children) {return h('small', args, ...children)}
function source(args, ...children) {return h('source', args, ...children)}
function spacer(args, ...children) {return h('spacer', args, ...children)}
function span(args, ...children) {return h('span', args, ...children)}
function strike(args, ...children) {return h('strike', args, ...children)}
function strong(args, ...children) {return h('strong', args, ...children)}
function style(args, ...children) {return h('style', args, ...children)}
function sub(args, ...children) {return h('sub', args, ...children)}
function summary(args, ...children) {return h('summary', args, ...children)}
function sup(args, ...children) {return h('sup', args, ...children)}
function table(args, ...children) {return h('table', args, ...children)}
function tbody(args, ...children) {return h('tbody', args, ...children)}
function td(args, ...children) {return h('td', args, ...children)}
function template(args, ...children) {return h('template', args, ...children)}
function textarea(args, ...children) {return h('textarea', args, ...children)}
function tfoot(args, ...children) {return h('tfoot', args, ...children)}
function th(args, ...children) {return h('th', args, ...children)}
function thead(args, ...children) {return h('thead', args, ...children)}
function time(args, ...children) {return h('time', args, ...children)}
function title(args, ...children) {return h('title', args, ...children)}
function tr(args, ...children) {return h('tr', args, ...children)}
function track(args, ...children) {return h('track', args, ...children)}
function tt(args, ...children) {return h('tt', args, ...children)}
function u(args, ...children) {return h('u', args, ...children)}
function ul(args, ...children) {return h('ul', args, ...children)}
function var_(args, ...children) {return h('var', args, ...children)}
function video(args, ...children) {return h('video', args, ...children)}
function wbr(args, ...children) {return h('wbr', args, ...children)}
function xmp(args, ...children) {return h('xmp', args, ...children)}

module.exports = {
    a,
	abbr,
	acronym,
	address,
	applet,
	area,
	article,
	aside,
	audio,
	b,
	base,
	basefont,
	bdi,
	bdo,
	bgsound,
	big,
	blink,
	blockquote,
	body,
	br,
	button,
	canvas,
	caption,
	center,
	cite,
	code,
	col,
	colgroup,
	content,
	data,
	datalist,
	dd,
	decorator,
	del,
	details,
	dfn,
	dir,
	div,
	dl,
	dt,
	element,
	em,
	embed,
	fieldset,
	figcaption,
	figure,
	font,
	footer,
	form,
	frame,
	frameset,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	head,
	header,
	hgroup,
	hr,
	html,
	i,
	iframe,
	img,
	input,
	ins,
	isindex,
	kbd,
	keygen,
	label,
	legend,
	li,
	link,
	listing,
	main,
	map,
	mark,
	marquee,
	menu,
	menuitem,
	meta,
	meter,
	nav,
	nobr,
	noframes,
	noscript,
	object,
	ol,
	optgroup,
	option,
	output,
	p,
	param,
	plaintext,
	pre,
	progress,
	q,
	rp,
	rt,
	ruby,
	s,
	samp,
	script,
	section,
	select,
	shadow,
	small,
	source,
	spacer,
	span,
	strike,
	strong,
	style,
	sub,
	summary,
	sup,
	table,
	tbody,
	td,
	template,
	textarea,
	tfoot,
	th,
	thead,
	time,
	title,
	tr,
	track,
	tt,
	u,
	ul,
	var_,
	video,
	wbr,
	xmp, h}
